import { HttpErrorResponse } from "@angular/common/http";

import { LoginModel } from "@core/models/login.model";
import { User } from "@core/models/user.model";
import { createAction, props } from "@ngrx/store";

export const DO_LOGIN = createAction(
  "[Auth] Do Login",
  props<{ credentials: LoginModel; target: string }>()
);

export const DO_INITIAL_LOGIN = createAction("[Auth] Do Initial Login");

export const LOGIN_SUCCESS = createAction(
  "[Auth] Login Success",
  //TODO replace any with User data from switchMap
  props<any>()
);

export const LOGIN_FAILED = createAction(
  "[Auth] Login Failed",
  props<{ error: HttpErrorResponse }>()
);

export const SET_LOGIN_LOADING = createAction(
  "[Auth] Set Login Loading",
  props<{ loading: boolean }>()
);

export const DO_LOGOUT = createAction("[Auth] Do Logout");

export const LOAD_USER_DATA = createAction("[Auth] Load User Data");

export const SET_USER_DATA = createAction(
  "[Auth] Set User Data",
  props<{ user: User }>()
);
